"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const vant_1 = require("vant"); // 引入要使用的组件
require("vant/lib/index.css");
const vue_1 = __importDefault(require("vue"));
const lang_1 = __importDefault(require("@/lang"));
const App_vue_1 = __importDefault(require("./App.vue"));
const router_1 = __importDefault(require("./router"));
const store_1 = __importDefault(require("./store"));
require("./plugins");
require("./filters");
require("./components");
require("./styles/index.scss");
const vue_baidu_map_1 = __importDefault(require("vue-baidu-map")); // 导入地图
vue_1.default.use(vant_1.AddressList);
vue_1.default.config.productionTip = false;
vue_1.default.prototype.$a = function (number, decimals, point, thousands) {
    /*
    * 参数说明：
    * number：要格式化的数字
    * decimals：保留几位小数
    * point：小数点符号
    * thousands：千分位符号
    * */
    number = (number + '').replace(/[^0-9+-Ee.]/g, '');
    let n = !isFinite(+number) ? 0 : +number, prec = !isFinite(+2) ? 0 : Math.abs(2), sep = (typeof thousands === 'undefined') ? ',' : thousands, dec = (typeof point === 'undefined') ? '.' : point, s = [], toFixedFix = function (n, prec) {
        let k = Math.pow(10, prec);
        return '' + Math.ceil(n * k) / k;
    };
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    let re = /(-?\d+)(\d{3})/;
    while (re.test(s[0])) {
        s[0] = s[0].replace(re, "$1" + sep + "$2");
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
};
// 进行全局注册，一次性引入百度地图组件库的所有组件,ak为官方提供的密钥
vue_1.default.use(vue_baidu_map_1.default, {
    ak: '1vZFKloLkFZsmhdXxFsNmb4EtN4ElpUt'
});
new vue_1.default({
    i18n: lang_1.default,
    router: router_1.default,
    store: store_1.default,
    render: (h) => h(App_vue_1.default)
}).$mount('#app');
